/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Error message for specific risk metric.
 * @export
 * @interface Warnings
 */
export interface Warnings {
  /**
   *
   * @type {number}
   * @memberof Warnings
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof Warnings
   */
  metricName: string;
  /**
   *
   * @type {string}
   * @memberof Warnings
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof Warnings
   */
  fileName: string;
}

/**
 * Check if a given object implements the Warnings interface.
 */
export function instanceOfWarnings(value: object): value is Warnings {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('metricName' in value) || value['metricName'] === undefined) return false;
  if (!('message' in value) || value['message'] === undefined) return false;
  if (!('fileName' in value) || value['fileName'] === undefined) return false;
  return true;
}

export function WarningsFromJSON(json: any): Warnings {
  return WarningsFromJSONTyped(json, false);
}

export function WarningsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Warnings {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    metricName: json['metric_name'],
    message: json['message'],
    fileName: json['file_name'],
  };
}

export function WarningsToJSON(value?: Omit<Warnings, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    metric_name: value['metricName'],
    message: value['message'],
    file_name: value['fileName'],
  };
}
